<!-- 検査項目マスタ　一覧画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wkkmm">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>検査項目マスタ</h2>
			<ul class="contntMenu">
				<li class="onBack" v-on:click="onBack">TOP</li>
			</ul>

			<!-- ▽  -->
			<section>
				<table class="listTbl">
 					<caption>
						<div class="btnLst">
							<button class="newBtn" v-on:click="onRegister">新規作成</button>
							<!-- ↑ contntMenu「TOP」に変更 <button class="backBtn" v-on:click="onBack">戻る</button> -->
						</div>
					 </caption>
					<!-- 一時的 -->
					<thead>
					<th>並び</th>
					<td>項目名称</td>
					<td></td>
					</thead>
					<tbody>
						<tr v-for="list in listKKMM" v-bind:key="list.KMNM">
							<th>
								{{list.SORT}}
							</th>
							<td>
								{{list.KMNM}}
							</td>
							<td class="btnLst">
								<button class="detailBtn" v-on:click="onDetail(list.KMCD)">詳細</button>
								<button class="dltBtn" v-on:click="onDeleteSub(list.KMCD)">削除</button>
							</td>
						</tr>
					</tbody>
				</table>
				<!--データが一件もない場合に表示-->
				<div v-if="listKKMM.length == 0">
					<p>データが一件も登録されていません。</p>
				</div>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!--モーダルWindow S -->
		<modalWindow v-show="modal.deleteRow.isShow" v-on:close="onDeleteRowModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.deleteRow.messages"></errorMessageBox>
				<ul class="btnLst">
					<li><button v-on:click="onDelete">削除</button></li>
					<li><button v-on:click="onCancel">キャンセル</button></li>
				</ul>
			</dd>
			<dd slot="modal-footer"></dd>
		</modalWindow>
		<!--モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WKKMMListApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import { WKKMMListDeleteApi } from '@/api'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWKKMMList',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},
		data() {
			return {
				//リスト表示用配列
				// IRCD 医療機関コード
				// KMCD 検査項目コード
				// SORT 並び
				// KMNM 項目名称
				listKKMM: [],
				// モーダルウィンドウ
				modal: {
					deleteRow: {
						messages: [
							'削除しますか？'
						],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					}
				},
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWKKMMList::created Start')

			var tempircd = this.$store.state.auth.ircd

			// 非同期通信
			WKKMMListApi.FirstDisplay({
				token: this.$store.state.auth.token,
				ircd: tempircd
			}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						this.listKKMM = responce.data.listKKMM

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWKKMMList::created End')
				})
		},
		methods: {
			// 新規作成ボタン
			onRegister: function () {
				UtilityConsoleLog.consoleLog("MasterWKKMMList::onRegister Start")

				//新規作成画面に遷移
				this.$router.push("/MasterWKKMMRegister")

				UtilityConsoleLog.consoleLog("MasterWKKMMList::onRegister End")
			},
			// メニューへ戻る
			onBack: function () {
				UtilityConsoleLog.consoleLog("MasterWKKMMList::onBack Start")

				this.$router.push("/AdminReserveStatusCheck")

				UtilityConsoleLog.consoleLog("MasterWKKMMList::onBack End")
			},
			//詳細ボタン
			onDetail: function (in_kmcd) {
				UtilityConsoleLog.consoleLog("MasterWKKMMList::onDetail Start")

				this.$store.commit(types.ADMIN_USERCHOICE_WKKMM_LISTTODETAIL, { kmcd: in_kmcd })

				this.$router.push("/MasterWKKMMDetail")

				UtilityConsoleLog.consoleLog("MasterWKKMMList::onDetail End")
			},
			//削除ボタン
			onDeleteSub: function (in_kmcd) {
				UtilityConsoleLog.consoleLog("MasterWKKMMList::onDeleteSub Start")

				//該当のTMZNをstoreに登録
				this.$store.commit(types.ADMIN_USERCHOICE_WKKMM_LISTTODETAIL, { kmcd: in_kmcd })

				//削除確認モーダルを開く
				this.onDeleteRowModalOpen()

				UtilityConsoleLog.consoleLog("MasterWKKMMList::onDeleteSub End")
			},
			//削除確認モーダルでの削除ボタン
			onDelete: function () {
				UtilityConsoleLog.consoleLog("MasterWKKMMList::onDelete Start")

				var tempircd = this.$store.state.auth.ircd
				var tempkmcd = this.$store.state.adminUserChoice.MasterWKKMM.kmcd

				WKKMMListDeleteApi.ListDelete({
					token: this.$store.state.auth.token,
					ircd: tempircd,
					kmcd: tempkmcd
				}).then(({ responce }) => {

						if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

							this.listKKMM = responce.data.listKKMM

							// モーダルウィンドウを閉じる
							this.modalClose('deleteRow')

							// ストアの初期化
							this.$store.commit(types.ADMIN_USERCHOICE_WTMZN_LISTTODETAIL, { kmcd: '' })

						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
							// システム、DBエラー時
							this.onSystemErrorModalOpen()
						}

					}).catch(() => {
						// システムエラー時
						this.onSystemErrorModalOpen()
					}).finally(() => {
						UtilityConsoleLog.consoleLog('MasterWKKMMList::onDelete End')
				})
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onDeleteRowModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWKKMMList::onDeleteRowModalOpen Start')

				this.modalOpen('deleteRow')

				UtilityConsoleLog.consoleLog('MasterWKKMMList::onDeleteRowModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onDeleteRowModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWKKMMList::onDeleteRowModalClose Start')

				this.modalClose('deleteRow')

				UtilityConsoleLog.consoleLog('MasterWKKMMList::onDeleteRowModalClose End')
			},
			//一覧表示画面に戻る
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWKKMMList::onCancel Start")

				this.$store.commit(types.ADMIN_USERCHOICE_WKKMM_LISTTODETAIL, {})

				this.modalClose('deleteRow')

				UtilityConsoleLog.consoleLog("MasterWKKMMList::onCancel End")
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWKKMMList::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWKKMMList::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWKKMMList::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWKKMMList::onSystemErrorModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWKKMMList::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWKKMMList::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWKKMMList::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWKKMMList::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WKKMM/MasterWKKMMList.vue